<template>
    <div>

        <!-- Cadastrar Paciente -->
        <div class="modal fade" id="cadastroNovoPacienteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="dados_novo_paciente">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Paciente</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-2" v-if="!dados_novo_paciente.id_pessoa && !dados_novo_paciente.paciente.verificado">
                            <cadastro-paciente-primeira-vez ref="cadPaciente1" v-model="dados_novo_paciente.paciente" />
                        </div>
                        <div class="mb-2" v-else>
                            <cadastro-paciente
                                :marcacao="marcacao"
                                v-model="dados_novo_paciente.paciente"
                                formName="cadpac"
                                :editar="true"
                                :noButtons="true"
                                ref="cadPaciente"
                                :validate="validate"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="dados_novo_paciente.paciente.verificado" @click="salvar_paciente()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import CadastroPacientePrimeiraVez from '../recepcao/CadastroPacientePrimeiraVez.vue';
import CadastroPaciente from "../../shared/CadastroPaciente.vue";
import AzSubmit from "../../util/AzSubmit.vue";


export default {
    data() {
        return { 
            dados_novo_paciente: null, 
        }
    },

    components: { 
        CadastroPacientePrimeiraVez, 
        CadastroPaciente, 
        AzSubmit, 
    },
    
    methods: { 
        salvar_paciente () {

            let marcacao = this.dados_novo_paciente.id_marcacao ? this.dados_novo_paciente : null;
            let lista_espera = this.dados_novo_paciente.id_lista_espera ? this.dados_novo_paciente : null;
            let autorizacao = this.dados_novo_paciente.id_solicitacao_autorizacao ? this.dados_novo_paciente : null;

            this.$util.atualizar(this, { 
                service: 'pacientes', 
                func: 'store',
                dados: { 
                    paciente: this.dados_novo_paciente.paciente,
                    marcacao: marcacao,
                    lista_espera: lista_espera, 
                    autorizacao: autorizacao, 
                    agenda: true, 
                },
                modal: 'cadastroNovoPacienteModal',
                callback: () => { 
                    this.$emit('refresh');
                } 
            });

        },

        abrir (item) { 
            if ( item.id_paciente ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Paciente já cadastrado.",
                    life: 5000
                });
                return;
            }

            this.dados_novo_paciente = null;

            this.$nextTick(() => { 
                this.validate = false;
                let dados = _.cloneDeep(item);

                dados.paciente = { 
                    id_pessoa: null,
                    verificado: false, 
                    st_nome: dados.cadastro_temporario.st_nome, 
                    cpf_nao_obrigatorio: false, 
                    cadastro: { 
                        ch_sexo: dados.cadastro_temporario.ch_sexo,
                        dt_nascimento: dados.cadastro_temporario.dt_nascimento, 
                        fl_estrangeiro: false, 
                        st_cpf: dados.cadastro_temporario.st_cpf, 
                        st_nome_mae: dados.cadastro_temporario.st_nome_mae,
                        st_rg: dados.cadastro_temporario.st_rg, 
                        st_email: dados.cadastro_temporario.st_email, 
                        telefones: { 
                            telefone: dados.cadastro_temporario.st_telefone,
                            celular: dados.cadastro_temporario.st_celular, 
                        },
                        endereco: { 
                            cidade: null, 
                        }, 
                    },
                    paciente_unidade: { 
                        st_numero_carteira: dados.cadastro_temporario.st_numero_carteira, 
                        dt_validade_carteira: dados.cadastro_temporario.dt_validade_carteira,
                        st_numero_prontuario: "", 
                        plano: dados.plano, 
                    },
                };

                this.dados_novo_paciente = dados;

                $('#cadastroNovoPacienteModal').modal('show');
            });
        },
    }
}
</script>
